import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function AuthNavigator() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Don't navigate while still loading
    if (loading) return

    // Handle user authentication state changes
    if (user) {
      // User is authenticated - redirect to dashboard if on login/register page
      // BUT allow /signup with partner parameters to show (for partner attribution)
      const hasPartnerParams = location.search.includes('partner=')
      const isSignupWithPartner = location.pathname === '/signup' && hasPartnerParams
      
      if ((location.pathname === '/login' || location.pathname === '/register' || location.pathname === '/') && !isSignupWithPartner) {
        console.log('🎯 User authenticated, navigating to dashboard')
        navigate('/dashboard', { replace: true })
      }
    } else {
      // User is not authenticated - redirect to login if on protected page
      const publicPaths = ['/login', '/register', '/signup', '/', '/unsubscribe', '/free-signup', '/pro', '/lifetime', '/pro-signup', '/lifetime-signup', '/whitelabel-setup', '/claim-account', '/signup-pro-monthly', '/signup-pro-yearly', '/signup-whitelabel']
      const isPublicPath = publicPaths.includes(location.pathname) || 
                          location.pathname.startsWith('/funnel/') ||
                          location.pathname.startsWith('/oauth/') ||
                          location.pathname.startsWith('/partner/')
      
      if (!isPublicPath) {
        console.log('🚪 User not authenticated, redirecting to login')
        navigate('/login', { replace: true })
      }
    }
  }, [user, loading, location.pathname, navigate])

  return null // This component only handles navigation logic
}